import React from 'react';
import { Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';

export const About3 = () => {
  return (
    <div className="about-main-container">
      <div className="about-cover about-3-image" />
      <div className="container">
        <Stack spacing={3} className="about-stack about-3-stack">
          <div className="about-title">How about putting the artist first?</div>
          <Typography className="about-description ">
            MusicArt is the music site that’s both a brand-new marketing tool
            and an income generating tool for musicians. Our platform uses an
            innovative “coupon” system that allows musicians to “give away” as
            many “copies” of their records as they like.
          </Typography>
          <Typography className="about-description ">
            Releasing music like this versus just making your songs randomly
            available to be streamed instantly by anyone turns your singles into
            desirable promo copies. That’s the marketing part. Here’s where the
            revenue kicks in: those same “promo records” can later be bought and
            sold, which will earn you, the artist, royalties every time that
            record changes hands, even though they were originally given out as
            free promo copies.
          </Typography>
          <Typography className="about-footer">
            Marketing that actually makes you money. Imagine that.
          </Typography>
        </Stack>
      </div>
    </div>
  );
};
